const waliItems = [
  { label: "Father", value: "Father" },
  { label: "Grandfather", value: "Grandfather" },
  { label: "Brother", value: "Brother" },
  { label: "Uncle", value: "Uncle" },
  { label: "I don't have a wali", value: "I don't have a wali" },
];
export default waliItems;
